<div style="width:250px">
	{{this.data.address}}
	<app-tooltip-center-sm
        *ngIf="this.tooltip === 'sm-center'"
        class="tooltip-span"
        [tooltip]="data.address">
    </app-tooltip-center-sm>
</div>
